var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "site-item",
      attrs: { href: _vm.coupon.cpu, target: "_blank" },
    },
    [
      _c("div", { staticClass: "item-wrap" }, [
        _c("div", { staticClass: "item-img" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              src: _vm.defaultImg,
              "data-src": _vm.getCouponImage(_vm.coupon.pi),
              alt: "" + _vm.coupon.pn,
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item-txt" }, [
          _c("div", { staticClass: "item-name" }, [
            _vm._v(_vm._s(_vm.coupon.pn)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "item-desc" }, [
            _vm._v(_vm._s(_vm.coupon.cpn)),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }